import 'pannellum';

const defaults = {
  type: 'equirectangular',
  autoLoad: true
};

class Panorama {
  constructor (element, settings) {
    this.element = element;
    this.options = Object.assign({}, defaults, settings, { panorama: element.dataset.image });
  }

  init () {
    this.panorama = window.pannellum.viewer(this.element, this.options);
  }
}

export default Panorama;
